import { render, staticRenderFns } from "./CustomerCUDialog.vue?vue&type=template&id=b31f338e&scoped=true"
import script from "./CustomerCUDialog.vue?vue&type=script&lang=js"
export * from "./CustomerCUDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerCUDialog.vue?vue&type=style&index=0&id=b31f338e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31f338e",
  null
  
)

export default component.exports